import React from 'react';
import PropTypes from 'prop-types';
import SimpleNotificationPopup from './SimpleNotificationPopup';

function getContent(type, message) {
  switch (type) {
    case 'CREATE_OWNERSHIP':
      return {
        title: 'create_ownership_popup_title',
        message: 'create_ownership_popup_msg',
        error: true,
      };
    case 'SAVE_PASSWORD':
      return {
        title: 'save_password_popup_title',
        message: 'save_password_popup_msg',
        error: true,
      };
    case 'EDIT_PERSONAL_DATA':
    case 'EDIT_CONTACT_DATA':
      return {
        title: 'edit_personal_data_popup_title',
        message: 'edit_personal_data_popup_msg',
        error: true,
      };
    case 'SAVE_NOTIFICATIONS_CONFIG':
      return {
        title: 'save_notification_config_popup_title',
        message: 'save_notification_config_popup_msg',
        error: true,
      };
    case 'SAVE_PASSWORD_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true,
      };
    case 'EDIT_DEVICE_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true,
      };
    case 'CONNECT_DEVICE_FAILURE':
      return {
        title: 'add_idea_confirmation_title',
        message: 'add_idea_confirmation_description',
      };
    case 'REGISTER_USER_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true,
      };
    case 'ADD_OWNERSHIP_FAILURE':
      return {
        title: 'add_ownership_failure_popup_title',
        message: 'add_ownership_failure_popup_msg',
        error: true,
      };
    case 'REMOVE_OWNERSHIP':
      return {
        title: 'remove_ownership_popup_title',
        message: 'remove_ownership_popup_msg',
        error: true,
      };
    case 'REMOVE_OWNERSHIP_FAILURE':
      return {
        title: 'remove_ownership_failure_popup_title',
        message: 'remove_ownership_failure_popup_msg',
        error: true,
      };
    case 'CREATE_OWNERSHIP_FAILURE':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true,
      };
    case 'CREATE_OWNERSHIP_LIMIT':
      return {
        title: 'blocked_interaction_popup_title',
        message: 'blocked_interaction_popup_msg',
        error: true,
      }; 
    case 'CREATE_OWNERSHIP_FAILURE_BAD_DATA':
      return {
        title: 'add_device_incorrect_serial_number_title',
        message: 'add_device_incorrect_serial_number_msg',
        error: true,
      }; 
    case 'CREATE_OWNERSHIP_FAILURE_FORBIDDEN':
      return {
        title: 'add_device_not_found_title',
        message: 'add_device_not_found_msg',
        error: true,
      }; 
    case 'CREATE_OWNERSHIP_FAILURE_LIMIT':
      return {
        title: 'add_device_unavailable_title',
        message: 'add_device_unavailable_msg',
        error: true,
      };
    case 'CREATE_OWNERSHIP_FAILURE_CODE':
      return {
        title: 'add_device_error_title',
        message: 'add_device_error_msg',
        error: true,
      };
    case 'REMOVE_PROTECTED_INSTALLATION':
      return {
        title: 'remove_device_from_installation_title',
        message: 'remove_device_from_installation_msg',
        error: true,
      };
    case 'REMOVE_PROTECTED_INSTALLATION_FAILURE_LIMIT':
      return {
        title: 'remove_device_from_installation_error_title',
        message: 'remove_device_from_installation_error_msg',
        error: true,
      };
    case 'SAVE_INSTALLATION_DATA':
      return {
        title: 'add_device_to_installation_title',
        message: 'add_device_to_installation_msg',
        error: true,
      };
    case 'SAVE_INSTALLATION_DATA_FAILURE_LIMIT':
      return {
        title: 'add_device_to_installation_already_exists_title',
        message: 'add_device_to_installation_already_exists_msg',
        error: true,
      };
    case 'SAVE_INSTALLATION_DATA_FAILURE_CODE':
      return {
        title: 'add_device_to_installation_not_exist_title',
        message: 'add_device_to_installation_not_exist_msg',
        error: true,
      };
    default:
      return null;
  }
}

export default function NotificationPopupTextContent(props) {
  const {data, closePopup} = props;
  const popupContent = getContent(data.get('type'), data.get('message'));
  return <SimpleNotificationPopup {...popupContent} onClose={closePopup} />;
}

NotificationPopupTextContent.propTypes = {
  data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  closePopup: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Popup/NotificationPopUpTextContent.js